import React, { Component } from 'react';
import { createCombineReducers } from 'mt-react-common/modules/coupons/reducers/activatedCouponForm/combine';
import ActivatedCouponForm from './ActivatedCouponForm';

class StatusesDescTableRWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `activatedCouponForm`
    };
  }

  componentWillMount() {
    createCombineReducers(this.state.reducerName);
  }

  render() {
    return (
      <React.Fragment>
        <ActivatedCouponForm
          {...this.props}
          reducerName={this.state.reducerName}
        />
      </React.Fragment>
    );
  }
}

export default StatusesDescTableRWrapper;



// WEBPACK FOOTER //
// ./src/components/Payments/ActivatedCouponForm/index.js